<div fxLayout="column" class="gradient" [hidden]="!colorMap" >
    <span [innerHTML]="colorMapHtml"></span>
    <span [class]="!this.rotate ? 'domain-min' : 'domain-min-rotate'">{{ domainMin }}</span>
    <span [class]="!this.rotate ? 'domain-med' : 'domain-med-rotate'">{{ domainMed }}</span>
    <span [class]="!this.rotate ? 'domain-max' : 'domain-max-rotate'">{{ domainMax }}</span>
  </div>
